export default {
  methods: {
    mixCalcularAnticipoFinanciado() {
      const {
        importeCostoFinanciero,
        porcentajeAvanceFinanciero,
        esEstimacionFiniquito,
      } = this.estimacion;

      let amortizacion = 0;
      // Calcular la amoritzacion de importe del anticipo financiado
      amortizacion = this.$numberRound((
        this.getImporteTotalAnticipoContratadoFinanciado
            * porcentajeAvanceFinanciero
      ));

      // si es la estimacion finiquito realizar la resta con el faltante
      if (esEstimacionFiniquito || this.amortizarAnticipo) {
        amortizacion = this.$numberRound((this.getImporteTotalAnticipoContratadoFinanciado
          - this.mixImporteCostoFinancieroAmortizacionAnticipoAnterior));
      }

      this.estimacion.importeCostoFinancieroAmortizacionAnticipo = amortizacion;
      this.estimacion.importeCostoFinancieroEstimacion = (importeCostoFinanciero - amortizacion);
    },
  },
  computed: {
    mixImporteCostoFinancieroAmortizacionAnticipoAnterior() {
      return this.$ObjSumar(this.estimaciones, 'importeCostoFinancieroAmortizacionAnticipo');
    },
  },
};
